// extracted by mini-css-extract-plugin
export default {"image-wrap":"image-wrap__2sNRA"};
    if(module.hot) {
      // 1792145974380
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  